export const ADD_NEW_STEP = 'ADD_NEW_STEP';
export const addNewStep = () => ({
  type: ADD_NEW_STEP,
});

/* export const SELECT_ADDON_STEP_TYPE = 'SELECT_ADDON_STEP_TYPE';
export const selectStepType = (addonType, step) => ({
  type: SELECT_ADDON_STEP_TYPE,
  addonType,
  step,
}); */

export const EDIT_ADDON_STEP_TITLE = 'EDIT_ADDON_STEP_TITLE';
export const editStepTitle = (title, step) => ({
  type: EDIT_ADDON_STEP_TITLE,
  title,
  step,
});

export const ADD_STEP_DATA = 'ADD_STEP_DATA';
export const addStepData = (step, data, addonType) => ({
  type: ADD_STEP_DATA,
  step,
  data,
  addonType,
});

export const CLEAR_ADDON_STEP = 'CLEAR_ADDON_STEP';
export const clearAddonStep = step => ({
  type: CLEAR_ADDON_STEP,
  step,
});

export const REMOVE_ADDON_STEP_ITEM = 'REMOVE_ADDON_STEP_ITEM';
export const removeStepAddonItem = (step, id) => ({
  type: REMOVE_ADDON_STEP_ITEM,
  step,
  id,
});

export const REMOVE_ADDON_STEP = 'REMOVE_ADDON_STEP';
export const removeAddonStep = step => ({
  type: REMOVE_ADDON_STEP,
  step,
});

export const CLEAR_ALL_ADDONS_STEPS = 'CLEAR_ALL_ADDONS_STEPS';
export const clearAllSteps = () => ({
  type: CLEAR_ALL_ADDONS_STEPS,
});

export const CLOSE_STEP_DATA_SELECTION_MODAL = 'CLOSE_STEP_DATA_SELECTION_MODAL';
export const closeStepDataModal = clearStep => ({
  type: CLOSE_STEP_DATA_SELECTION_MODAL,
  clearStep,
});

export const SELECT_CURRENT_STEP_SELECTION = 'SELECT_CURRENT_STEP_SELECTION';
export const selectCurrentStepSelection = (step, addonType) => ({
  type: SELECT_CURRENT_STEP_SELECTION,
  addonType,
  step,
});

export const ADD_VARIATION_ITEM = 'ADD_VARIATION_ITEM';
export const addVariationItem = (variation, order, isGlobal) => ({
  type: ADD_VARIATION_ITEM,
  variation,
  order,
  isGlobal,
});

export const EDIT_VARIATION_ITEM = 'EDIT_VARIATION_ITEM';
export const editVariationItem = variation => ({
  type: EDIT_VARIATION_ITEM,
  variation,
});

export const REMOVE_VARIATION_ITEM = 'REMOVE_VARIATION_ITEM';
export const removeVariationItem = variationId => ({
  type: REMOVE_VARIATION_ITEM,
  variationId,
});

export const ORDER_VARIATION_ITEM = 'ORDER_VARIATION_ITEM';
export const orderVariationItem = (variationId, currPos, newPos) => ({
  type: ORDER_VARIATION_ITEM,
  variationId,
  currPos,
  newPos,
});

export const SET_COMBO_STEPS = 'SET_COMBO_STEPS';
export const setComboSteps = steps => ({
  type: SET_COMBO_STEPS,
  steps,
});

export const SET_PRODUCT_VARIATIONS_DATA = 'SET_PRODUCT_VARIATIONS_DATA';
export const setProductVariationsData = variations => ({
  type: SET_PRODUCT_VARIATIONS_DATA,
  variations,
});



// WEBPACK FOOTER //
// ./src/store/productAddons/actions.js